export enum CDefine {
	MAX_ERRMSG_LEN = 64,
	TOTAL_MJ_CARDS = 144,
	CARDS_PER_PLAYER = 16,
	PLAYER_NUMS = 4,

	ROBOT_NETIDX = -1000,

	MJTYPE_WANNS = 1,
	MJTYPE_TOONG = 2,
	MJTYPE_SUOOS = 3,
	MJTYPE_WORDS = 4,
	MJTYPE_FLOWERS = 5,

    MJ_PAIRS = 0x10,
	MJ_STRIPLE = 0x20,
	MJ_KTRIPLE = 0x40,
	MJ_GUNNS = 0x80, 

	MJACTION_THI = 0x01,
	MJACTION_PON = 0x02,
	MJACTION_GUN = 0x04,
	MJACTION_TING = 0x08,
	MJACTION_HUO = 0x10,
	MJACTION_HUAHUO = 0x20,
	MJACTION_HUCG = 0x40,

	MJ_Z4MO2 = 0x1000,
	MJ_CHUANG3GANG4 = 0x2000,

	STATE_SEL_THI = 5000,
	STATE_SEL_GUN = 6000,

	GEND_HUO = 0x01,
	GEND_LIU2JU2 = 0x02,
	GEND_HE4JU2 = 0x04,
	GEND_SPECHUO = 0x08,
	GEND_SHOW = 0x8000,

	GUILDNAME_LEN = 25,

	GOLD_MULTI_BASE = 10,

	LOGIN_LINE = 1,
	LOGIN_TESTER = 2,
	LOGIN_APPLE = 3,

	RETURN_URL_LEN = 4096,
}

export enum CEnumTypes {
	DISMISS_YES = 1,
	DISMISS_NO,
	DISMISS_DONE,
	
	ENDGAME_NORMAL = 1,
	ENDGAME_TIMEOUT,
	ENDGAME_DISMISS,
	ENDGAME_DISCONNECT,
	ENDGAME_BASELIMIT,

	ID_MSG_GFEEDBACK = 100,
	ID_MSG_ENTER_GAME,
	ID_MSG_LEAVE_GAME,

	ID_MSG_GLOBAL_LOGIN = 30,
	ID_MSG_GLOBAL_LOGOUT,
	ID_MSG_LOBBY_SESSION,
	ID_MSG_GAME_SESSION,
	// By default, enums will initialize the first value to 0 and add 1 to each additional value:
	D_MSG_GAMESERVER_STATUS = 88,
	ID_MSG_RECONNECT_DATA,
	
	ID_MSG_FEEDBACK = 100,
	ID_MSG_GAMESERVER_USED,
	// ID_MSG_SERVER_LOGIN,
	// ID_MSG_SERVER_LOGOUT,
	// ID_MSG_SERVER_SHUTDOWN,

	ID_MSG_ENTER_LOBBY = 120,
	ID_MSG_TABLE_CREATE,
	ID_MSG_TABLE_JOIN,
	ID_MSG_TABLE_LEAVE,
	ID_MSG_TABLE_STATUS,
	ID_MSG_TABLE_GETINFO,
	ID_MSG_TABLE_READY,
	ID_MSG_TABLE_END,
	ID_MSG_TABLE_START,

	ID_MSG_GUILD_ENTER,
	ID_MSG_GUILD_INFO_UPDATE,
	ID_MSG_GUILD_ROOM_ADD,
	ID_MSG_GUILD_ROOM_UPDATE,
	ID_MSG_GUILD_ROOM_REMOVE,
	ID_MSG_GUILD_LEAVE,
	ID_MSG_QUIT_GUILD,

	ID_MSG_GAME_FINAL_RESULT = 149,
	ID_MSG_GAME_MESSAGE,
	ID_MSG_GAME_RESULT,
	ID_MSG_ENDGAME,
	ID_MSG_GAME_START,					// game
	ID_MSG_GAME_LOGIN,
	ID_MSG_ERROR,

	ID_MSG_REQUEST_REPLAY = 200,
	ID_MSG_IAP_VERIFY_IOS,
	ID_MSG_IAP_VERIFY_ANDROID,
	ID_MSG_IAP_VERIFY_FEEDBACK,
	ID_MSG_DEL_ACCOUNT,

	ID_MSG_ACK = 250,
}

export enum CMJClass {
	MJSTATE_DICE = 9,
	MJSTATE_DEAL_E = 11,
	MJSTATE_PLAY = 15,
	MJSTATE_TPGH = 17,
	MJSTATE_SELCARD = 18,
	MJSTATE_PRERESULT = 26,
	MJSTATE_CHKRESULT = 27,
	MJSTATE_FIRSTCARDALLREADY = 37,
	MJSTATE_LIU2JU2_S = 38,
	
	MJGAME_DISCONNECTION = 20,
	MJGAME_LOGINSTATUS,
	MJGAME_DECIDESEAT,
	MJGAME_SHUFFLE,
	MJGAME_CHECKFLOWER,
	MJGAME_FIRSTCARDIN,
	MJGAME_PLAYERCARDIN,
	MJGAME_CARDINREADY,
	MJGAME_ACTIONMENU,
	MJGAME_ACTIONSEL,
	MJGAME_WAITCARDOUT,
	MJGAME_PLAYERCARDOUT,
	MJGAME_CARDOUTREADY,
	MJGAME_ACTIONSELREADY,

	MJGAME_SHOWRULETIP = 55,
	MJGAME_PREPARERESULT = 60,
	MJGAME_PREPARERESULTREADY,
	MJGAME_DORESULT,
	MJGAME_DORESULTREADY,
	MJGAME_NEXTROUND,

	MJGAME_COUNTDOWN = 80,
	MJGAME_REQUEST_DISMISS,
	MJGAME_FEEDBACK_DISMISS,
	MJGAME_END_DISMISS,

	MJGAME_GAMEOVER = 90,

	MJGAME_SYNCCARDS = 100,
};

export enum CMJHuType {
	HU_莊家 = 0,
	HU_連 = 1,
	HU_拉 = 2,
	HU_台 = 3,
	HU_門清 = 4,
	HU_自摸 = 5,
	HU_門清自摸 = 6,
	HU_槓上開花 = 7,
	HU_海底撈月 = 8,
	HU_搶槓 = 9,
	HU_全求 = 10,
	HU_獨聽 = 11,
	HU_門風 = 12,
	HU_圈風 = 13,
	HU_花牌 = 14,
	HU_花槓 = 15,
	HU_八仙過海 = 16,
	HU_平胡 = 17,
	HU_碰碰胡 = 18,
	HU_三暗刻 = 19,
	HU_四暗刻 = 20,
	HU_五暗刻 = 21,
	HU_混一色 = 22,
	HU_清一色 = 23,
	HU_小三元 = 24,
	HU_大三元 = 25,
	HU_小四喜 = 26,
	HU_大四喜 = 27,
	HU_七搶一 = 28,
	HU_天胡 = 29,
	HU_地胡 = 30,
	HU_聽牌 = 31,
	HU_紅中 = 32,
	HU_青發 = 33,
	HU_白板 = 34,
	HU_屁胡 = 35,
	HU_天聽 = 36,
	HU_地聽 = 37,
	HU_東風 = 38,
	HU_南風 = 39,
	HU_西風 = 40,
	HU_北風 = 41,
	HU_無字無花 = 42,
	HU_槓牌 = 43,
	HU_暗槓 = 44,
	HU_河底撈魚 = 45,
	HU_字一色 = 46,
	HU_清老頭 = 47,
	HU_四槓 = 48,
	HU_斷么九 = 49,
	HU_雙龍抱 = 50,
	HU_三色同順 = 51,
	HU_一條龍 = 52,
	HU_混全帶么 = 53,
	HU_純全帶么 = 54,
	HU_混老頭 = 55,
	HU_豹子 = 52,
	HU_天公伯牌自摸 = 53,
	HU_天公伯牌胡 = 54,
	HU_天公伯牌 = 55,
	HU_合計 = 56,
	MJHUO_MAXMATCH = HU_合計,
};
